import { useCallback, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom-v5-compat'
import isObject from 'lodash/isObject'

const useFilterHandlers = (filterModel, setFilterModel, includeHiddenColumns = false) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const urlFilter = searchParams.get('filter')

  const removeUrlFilter = useCallback(() => {
    if (urlFilter) {
      searchParams.delete('filter')
      setSearchParams(searchParams)
    }
  }, [searchParams, setSearchParams, urlFilter])

  const handleFilterModelChange = useCallback(
    newFilterModel => {
      setFilterModel({
        ...newFilterModel,
        ...(includeHiddenColumns && { quickFilterExcludeHiddenColumns: false }),
      })
      removeUrlFilter()
    },
    [setFilterModel, removeUrlFilter, includeHiddenColumns]
  )

  const handleRemoveFilter = useCallback(
    filterId => {
      setFilterModel({
        ...filterModel,
        items: filterModel.items.filter(item => item.id !== filterId),
      })
      removeUrlFilter()
    },
    [filterModel, setFilterModel, removeUrlFilter]
  )

  const handleUrlFilter = useCallback(() => {
    if (!urlFilter) return

    try {
      const parsedFilter = JSON.parse(decodeURIComponent(urlFilter))
      if (isObject(parsedFilter)) {
        setFilterModel(parsedFilter)
      }
    } catch (error) {
      console.error('Error parsing filter from URL:', error)
    }
  }, [urlFilter, setFilterModel])

  useEffect(() => {
    if (!urlFilter) return

    handleUrlFilter()
  }, [urlFilter])

  return {
    handleFilterModelChange,
    handleRemoveFilter,
  }
}

export default useFilterHandlers
